import React from 'react'
import { useFieldArray, useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { Button, Header, Segment, Table } from 'semantic-ui-react'
import FeedAdditiveItem from './FeedAdditiveItem'

interface HerdGroupFeedAdditivesProps {
  herdIndex: number
}

const HerdGroupFeedAdditives: React.FC<HerdGroupFeedAdditivesProps> = ({ herdIndex }) => {
  const { t } = useTranslation()
  const { control } = useFormContext()

  const { fields, append, remove } = useFieldArray({
    control,
    name: `herdGroups[${herdIndex}].feedAdditives`,
    keyName: 'key'
  })

  return (
    <>
      <Header attached='top' block>
        {t('Feed Additives')}
      </Header>
      <Segment attached>
        <Table celled>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell>{t('Additive Type')}</Table.HeaderCell>
              <Table.HeaderCell>{t('Dose')}</Table.HeaderCell>
              <Table.HeaderCell>{t('Dose Unit')}</Table.HeaderCell>
              <Table.HeaderCell>{t('Days')}</Table.HeaderCell>
              <Table.HeaderCell>{t('Herd Category %')}</Table.HeaderCell>
              <Table.HeaderCell>{t('Actions')}</Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {fields.map((field, additiveIndex) => (
              <FeedAdditiveItem
                key={field.key}
                id={field.key}
                index={additiveIndex}
                herdIndex={herdIndex}
                removeFeedAdditive={remove}
              />
            ))}
          </Table.Body>
        </Table>
        <div style={{ display: 'flex', justifyContent: 'end', marginTop: '1em' }}>
          <Button
            type='button'
            size='small'
            icon='plus'
            style={{ color: 'white' }}
            content={t('Add Feed Additive')}
            onClick={() => append({
              type: null,
              dose: null,
              doseUnit: null,
              days: null,
              herdCategoryPercentage: null
            })}
          />
        </div>
      </Segment>
    </>
  )
}

export default HerdGroupFeedAdditives
